// extracted by mini-css-extract-plugin
export default {"content":"RequestHistory_content__-0Eov","header":"RequestHistory_header__lFOBo","tableWrapper":"RequestHistory_tableWrapper__7a6gI"};